/** Local storage with the versioned keys from spec/formats.md. Every access is guarded. */

export const KEY_PREFIX = "mistsweeper.v1.";

/**
 * `&store=0` keeps the game's storage in memory for this visit, starting empty: the theme lab's
 * frames (decision 0034) play on the player's own site and must leave their runs, settings and
 * clearings as they were.
 */
const memory: Map<string, string> | null =
  typeof location !== "undefined" && new URLSearchParams(location.search).get("store") === "0"
    ? new Map()
    : null;

export function getJson<T>(name: string): T | null {
  try {
    const raw = memory
      ? (memory.get(KEY_PREFIX + name) ?? null)
      : localStorage.getItem(KEY_PREFIX + name);
    return raw === null ? null : (JSON.parse(raw) as T);
  } catch {
    return null;
  }
}

export function setJson(name: string, value: unknown): void {
  try {
    if (memory) memory.set(KEY_PREFIX + name, JSON.stringify(value));
    else localStorage.setItem(KEY_PREFIX + name, JSON.stringify(value));
  } catch {
    // Storage may be full or blocked; the game keeps working without persistence.
  }
}

export function remove(name: string): void {
  try {
    if (memory) memory.delete(KEY_PREFIX + name);
    else localStorage.removeItem(KEY_PREFIX + name);
  } catch {
    // Same as above.
  }
}
